<template>
    <canvas ref="canvas"></canvas>
</template>

<script>
export default {
    name: 'DotAnimation',
    methods: {
        updateCanvasSize() {
            const canvas = this.$refs.canvas;
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }
    },
    mounted() {
        this.updateCanvasSize();
        window.addEventListener('resize', this.updateCanvasSize);

        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext('2d');
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.lineWidth = 0.5;

        const points = [];
        const numberOfPoints = 200;
        const maxDistance = 80;
        const speed = 0.3;

        class Point {
            constructor(isSpecial = false) {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.speedX = (Math.random() - 0.5) * speed;
                this.speedY = (Math.random() - 0.5) * speed;
                this.radius = isSpecial ? 3 : 1;
                this.isSpecial = isSpecial;
                this.glowRadius = isSpecial ? 8 : 0;
            }

            update() {
                this.x += this.speedX;
                this.y += this.speedY;
                if (this.x < 0 || this.x > canvas.width) this.speedX *= -1;
                if (this.y < 0 || this.y > canvas.height) this.speedY *= -1;
            }

            draw() {
                if (this.isSpecial) {
                    const gradient = ctx.createRadialGradient(
                        this.x, this.y, 0,
                        this.x, this.y, this.glowRadius
                    );
                    gradient.addColorStop(0, 'rgba(255, 255, 0, 0.8)');
                    gradient.addColorStop(1, 'rgba(255, 255, 0, 0)');
                    ctx.beginPath();
                    ctx.arc(this.x, this.y, this.glowRadius, 0, Math.PI * 2);
                    ctx.fillStyle = gradient;
                    ctx.fill();
                }

                ctx.beginPath();
                ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
                ctx.fillStyle = this.isSpecial ? '#ffff00' : 'white';
                ctx.fill();
                if (this.isSpecial) {
                    ctx.strokeStyle = 'rgba(255, 255, 0, 0.5)';
                    ctx.stroke();
                }
                ctx.closePath();
            }
        }

        points.push(new Point(true));
        for (let i = 1; i < numberOfPoints; i++) {
            points.push(new Point());
        }

        function drawLines() {
            for (let i = 0; i < points.length; i++) {
                for (let j = i + 1; j < points.length; j++) {
                    const dx = points[i].x - points[j].x;
                    const dy = points[i].y - points[j].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < maxDistance) {
                        const opacity = 0.5 * (1 - (distance / maxDistance));
                        ctx.beginPath();
                        ctx.moveTo(points[i].x, points[i].y);
                        ctx.lineTo(points[j].x, points[j].y);
                        ctx.strokeStyle = `rgba(255, 255, 255, ${opacity})`;
                        ctx.stroke();
                    }
                }
            }
        }

        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            points.forEach(point => {
                point.update();
                point.draw();
            });
            drawLines();
            requestAnimationFrame(animate);
        }

        animate();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateCanvasSize);
    }
}
</script>

<style scoped>
canvas {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #020329;
    z-index: -1;
}
</style>
